export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const UPDATE_CART_TOTAL = 'UPDATE_CART_TOTAL';
export const UPDATE_CART_TOTAL_PRICE = 'UPDATE_CART_TOTAL_PRICE';
